import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselStatusPopupComponent } from './vessel-status-popup.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    VesselStatusPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports:[
    VesselStatusPopupComponent
  ]
})
export class VesselStatusPopupModule { }
